import { useNavigate, useParams } from "react-router-dom";
import { useGetSparePartDetailsQuery, useGetModelsQuery } from "../../service/features/api";
import { VEHICLE_CONDITION } from "../../constants/enum";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { SaudiRiyal } from "lucide-react";
const ManageSparePartsDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: detailsData } = useGetSparePartDetailsQuery(id, { skip: !id });
  const data = detailsData?.data;

  // Fetch models to resolve model name if it's just an ID
  const { data: modelsData } = useGetModelsQuery(
    { brandId: data?.brand?._id, page: 1, limit: 100 },
    { skip: !data?.brand?._id }
  );

  const modelName =
    data?.model?.name ||
    modelsData?.data?.data?.find((m: any) => m._id === data?.model)?.name ||
    "N/A";

  if (!data) return <p>Loading...</p>;

  const sparePartInfo = [
    { label: "Spare Part Name", value: data.name },
    {
      label: "Price",
      value: (
        <>
          <strong className="c_primary" style={{ display: "flex", alignItems: "center", gap: "4px" }}><SaudiRiyal size={16} />{data.discountPrice}</strong>{" "}
          <del><SaudiRiyal size={16} />{data.actualPrice}</del>
        </>
      ),
    },
    { label: "Category", value: data.categoryId?.name || "N/A" },
    { label: "Sub Category", value: data.subCategoryId?.name || "N/A" },
    { label: "OEM Number", value: data.oemNumber },
    {
      label: "Condition",
      value: data.condition
        ? Object.keys(VEHICLE_CONDITION).find(key => (VEHICLE_CONDITION as any)[key] === Number(data.condition))?.replace(/_/g, ' ') || "N/A"
        : "N/A"
    },
    // {
    //   label: "Small Description",
    //   value: data.shortDescription,
    // },
    {
      label: "Full Description",
      value: data.fullDescription,
    },
    { label: "Created Date", value: new Date(data.createdAt).toLocaleDateString() },
  ];

  const compatibilityInfo = [
    { label: "Brand / Make", value: data.brand?.name || "N/A" },
    { label: "Model", value: modelName },
    { label: "Year", value: data.manufacturingYear || "N/A" },
  ];

  const dealerInfo = [
    {
      label: "Dealer Name",
      value: (
        <strong
          className="anchor_link"
          onClick={() => navigate("/manage-dealers/detail")}
        >
          {data.dealer?.fullName || "N/A"}
        </strong>
      ),
    },
    { label: "Phone Number", value: data.dealer?.phone || "N/A" },
    { label: "Email", value: data.dealer?.email || "N/A" },
  ];

  const images = data.images && data.images.length > 0 ? data.images : ["/static/images/placeholder.png"];

  return (
    <>
      {/* Page Title */}
      <CommonBreadcrumb
        title="Spare Part Detail"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Listed Spare Parts", onClick: () => navigate("/manage-spare-parts") },
          { label: "Spare Part Detail" },
        ]}
      />

      {/* ================= Card 1: Spare Part Info ================= */}
      <div className="cards view_page">
        <div className="table_header mb_20">
          <h2>Spare Part Information</h2>
          <span className={`status_btn dark ${data.isActive ? "c_success" : "c_danger"}`}>
            {data.isActive ? "Active" : "Inactive"}
          </span>
        </div>

        <div className="gap_p">
          {/* Images */}
          <div className="w_100">
            <h6>Spare Part Images</h6>
            <div className="gap_p">
              {images.map((img: string, index: number) => (
                <div className="w_25" key={index}>
                  <div className="vew_img no_radius v2">
                    <figure>
                      <img src={img} className="view_img" alt="" />
                    </figure>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Spare Part Details */}
          {sparePartInfo.map((item, index) => (
            <div
              className={item.label.includes("Description") ? "w_100" : "w_33"}
              key={index}
            >
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ================= Card 2: Vehicle Compatibility ================= */}
      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Vehicle Compatibility</h2>
        </div>

        <div className="gap_p">
          {compatibilityInfo.map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ================= Card 3: Dealer Info ================= */}
      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Dealer Information</h2>
        </div>

        <div className="gap_p">
          {dealerInfo.map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ManageSparePartsDetail;